import React from 'react'
import { makeStyles,Drawer, Divider,IconButton,
        CardMedia ,Box, Typography,Card} from '@material-ui/core'
import Listas from './Listas';
import MenuIcon from '@material-ui/icons/Menu'; 
const drawerWidth = 240;

const estilos = makeStyles(theme=>({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
      },
      barra:{
        flexGrow:2
    },
    menuButton: {
        marginRight: theme.spacing(2),
        
      },
    media: {
        height: 152,
        width: 220,
        borderRadius: '10px',
      },
    eltoolbar:theme.mixins.toolbar,
    drawerPaper: {
    width: drawerWidth,
    background: process.env.REACT_APP_Fondo_Color,
    color:'white'
    },
}))
const Cajon = (propiedades) => {
    const misclases =estilos()
    return (
        <Drawer 
            className={misclases.drawer} variant={propiedades.variant??"permanent"}
            open={propiedades.open} onClose={propiedades.onClose ? propiedades.onClose:null }
            classes={ { paper: misclases.drawerPaper, } } anchor="left"
        >
            <Box className={misclases.eltoolbar} textAlign="center" pt={2} >
            
                <Typography color="inherit"  
                    variant = { propiedades.usuario.Nombre.length > 15 ? "body2" : "h5" } 
                >
                    <IconButton color="inherit"   onClick={()=>propiedades.funcionAbrir()} 
                    className={misclases.menuButton} aria-label="menu" size='small'
                >
                <MenuIcon/>
            </IconButton>
                    { propiedades.usuario.Nombre.toUpperCase() }                
                </Typography>
            </Box>
        
            <Divider/>
            <Listas className={misclases.barra} funcionAbrir={propiedades.funcionAbrir}/>
         {/*    <Box display="flex"   mt={3}  px={1} mb={2}   alignContent="flex-end">
                
                <Card  className={misclases.media} style={{justifyItems:"center"}}>
                    <CardMedia    style={{ width:"12rem", marginTop:"1.5rem"}}                             
                        component="img" alt="Logo Justicia"
                        scaleType="fitCenter" image="/logo_rectangular_todos.svg"
                        title="Logo Justicia"
                    />
                </Card>
            </Box>  */} 
            <Box display="flex" mt={2}  px={1} mb={2} alignItems="flex-end"  alignContent="flex-end">
                <Card  className={misclases.media} style={{justifyItems:"center"}}>
                    <CardMedia    style={{width:"8rem", marginTop:".8rem"}}                             
                        component="img" alt="Logo pj"
                        scaleType="fitCenter" image="/icono_base_m.svg"
                        title="Logo pj"
                    />
                </Card>
                
            </Box>              
            <Box>
                <Typography style={{paddingBottom:".6rem",  textAlign:"center"}}>by DADUVA Systems 2026</Typography>
            </Box>
    </Drawer>
    )
}

export default Cajon
